/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { getVariantPath } from '../../utils/get-variant-path'

export const stylePath = (field, variant) =>
  getVariantPath({
    atomicType: 'elements',
    componentId: 'logo-collection',
    variantName: variant,
    field,
  })

const LogoCollection = ({ logoImage, className, variant }) => (
  <div
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      variant: stylePath('outer', variant),
    }}
    className={className}
  >
    <For each='img' of={logoImage} index='i'>
      <div key={img.key || i} sx={{ variant: stylePath('inner', variant) }}>
        {img}
      </div>
    </For>
  </div>
)

export default LogoCollection
